import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TextField from "components/basic/textField";
import Typography from "components/basic/typography";
import { ReviseQuoteDraft } from "../../types";

export interface PricingSectionProps {
  draft: ReviseQuoteDraft;
  onChange: (patch: Partial<ReviseQuoteDraft>) => void;
}

/** The charger and installation the customer is billed for. */
const PricingSection: React.FC<PricingSectionProps> = ({ draft, onChange }) => {
  const theme = useTheme();
  const { t } = useTranslation("leads");

  const row: React.CSSProperties = {
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "flex-start",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
      }}
    >
      <Typography variant="subtitle2">{t("revise.pricing")}</Typography>

      <div style={row}>
        <div style={{ flex: 2 }}>
          <TextField
            name="chargerModel"
            label={t("revise.charger_model")}
            value={draft.chargerModel}
            isRequired
            onChange={(e) => onChange({ chargerModel: e.target.value })}
          />
        </div>
        <div style={{ flex: 1 }}>
          <TextField
            name="chargerCost"
            label={t("revise.charger_cost")}
            type="number"
            value={draft.chargerCost}
            isRequired
            onChange={(e) => onChange({ chargerCost: e.target.value })}
          />
        </div>
      </div>

      <div style={row}>
        <div style={{ flex: 1 }}>
          <TextField
            name="installationCost"
            label={t("revise.installation_cost")}
            type="number"
            value={draft.installationCost}
            isRequired
            onChange={(e) => onChange({ installationCost: e.target.value })}
          />
        </div>
        <div style={{ flex: 2 }} />
      </div>
    </div>
  );
};

export default PricingSection;
